export default __webpack_public_path__ + "static/media/googlePay.7118430a.svg";